
// mutations
const CAFETERIA_REQUESTS_EXTERNAL_ALL = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequestsExt = cafeteriaRequests.data
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const CAFETERIA_REQUESTS_EXTERNAL_TURNS = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequestsExt.turns = cafeteriaRequests.data
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}
const CAFETERIA_REQUESTS_EXTERNAL_DISPATCH = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequestsExt.user = cafeteriaRequests.data
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.cafeteriaRequestsExt = []
    state.status = 'error'
  }
}

const CAFETERIA_REQUESTS_EXTERNAL_PRODUCTS = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequestsExt.products = cafeteriaRequests.data
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}

const PAPELERIA_REQUESTS_EXTERNAL_PRODUCTS = (state, cafeteriaRequests) => {
  if (cafeteriaRequests.code === 1) {
    state.cafeteriaRequestsExt.products = cafeteriaRequests.data
    state.status = 'success'
  } else {
    alert(cafeteriaRequests.message)
    state.status = 'error'
  }
}


const CREDENTIAL_CLEAR = (state)=>{
  state.cafeteriaRequests = []
  console.log("cleaaaaar",state.cafeteriaRequests)
}

export default {
  CAFETERIA_REQUESTS_EXTERNAL_ALL,
  CAFETERIA_REQUESTS_EXTERNAL_TURNS,
  CAFETERIA_REQUESTS_EXTERNAL_DISPATCH,
  CAFETERIA_REQUESTS_EXTERNAL_PRODUCTS,
  PAPELERIA_REQUESTS_EXTERNAL_PRODUCTS,
  CREDENTIAL_CLEAR
}



// WEBPACK FOOTER //
// ./src/store/modules/external/mutations.js